import { Modal, Button } from "react-bootstrap";

const DeleteInvoiceModal = ({ show, handleClose, onDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Invoice</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Are you sure you want to delete this invoice?
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteInvoiceModal;